/* eslint-disable import/prefer-default-export */
export const COOKIE_POLICY_ACCEPT = 'CS/COOKIE_POLICY_ACCEPT';
